/** An editable UI proposal, never a provider/accounting classification. */
export const isWoltCommissionPresetName = (name) => /(?:^|[\s\p{P}])WOLT(?=$|[\s\p{P}])/u.test(name.normalize('NFKC').toUpperCase());
export function parseCashCommissionRate(value) {
    const normalized = value.trim().replace(',', '.');
    if (!/^\d{1,3}(?:\.\d{1,2})?$/.test(normalized))
        return null;
    const [whole, fraction = ''] = normalized.split('.');
    const basisPoints = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
    return basisPoints <= 10000n ? basisPoints : null;
}
/** Round the fee once to currency minor units; cash is the exact residual. */
export function cashCommissionByPercent(grossMinor, rate) {
    const basisPoints = parseCashCommissionRate(rate);
    if (grossMinor === null ||
        !/^\d+$/.test(grossMinor) ||
        BigInt(grossMinor) <= 0n ||
        basisPoints === null)
        return null;
    const gross = BigInt(grossMinor), fee = (gross * basisPoints + 5000n) / 10000n;
    return { feeMinor: fee.toString(), cashMinor: (gross - fee).toString() };
}
